import React from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import useIsPhone from "features/files/use-is-phone";

interface FileUploadAreaProps {
  id: string;
  multiple?: boolean;
  /** Another upload is running. */
  disabled: boolean;
  onFiles: (files: File[]) => void;
}

/** A dashed area that opens the file chooser wherever inside its border it is tapped. */
export default function FileUploadArea({ id, multiple, disabled, onFiles }: FileUploadAreaProps) {
  const { t } = useTranslation();
  const isPhone = useIsPhone();

  return (
    <>
      <input
        type="file"
        className="hidden"
        id={id}
        accept=".pdf,.jpg,.jpeg,.png"
        multiple={multiple}
        disabled={disabled}
        onChange={(e) => {
          const files = e.target.files;
          if (files && files.length > 0) onFiles(Array.from(files));
          e.target.value = "";
        }}
      />
      <label
        htmlFor={id}
        className={clsx(
          "block w-full rounded-lg border-2 border-dashed border-gray-300 p-4 text-center cursor-pointer hover:border-gray-400 transition-colors",
          disabled && "pointer-events-none opacity-50"
        )}
      >
        {/* Nothing is dropped on a phone: it opens the chooser. */}
        <p className="text-sm text-gray-500">{isPhone ? t("choose_file") : t("drop_file_or_click")}</p>
        <p className="text-xs text-gray-400 mt-1">PDF, JPG, PNG</p>
      </label>
    </>
  );
}
